<template>
  <div class="columns">
    <div class="column">
      <div class="title is-5">{{ $t("semifinal") }}</div>
      <div class="mb-5">
        <div
          class="button is-medium match0"
          v-bind:class="{
            'is-info': match_0_winner && match_0_winner == players[0],
          }"
          @click="win(0, players[0], $event)"
        >
          {{ players[0] }}
        </div>
      </div>
      <div>
        <div
          class="button is-medium match0"
          v-bind:class="{
            'is-info': match_0_winner && match_0_winner == players[1],
          }"
          @click="win(0, players[1], $event)"
        >
          {{ players[1] }}
        </div>
      </div>
    </div>
    <div class="column">
      <div class="title is-5">{{ $t("final") }}</div>
      <div>
        <div
          class="button is-medium match2"
          v-bind:class="{
            'is-info':
              match_2_winner &&
              match_0_winner &&
              match_2_winner == match_0_winner,
          }"
          @click="win(2, match_0_winner, $event)"
        >
          {{ match_0_winner }}
        </div>
      </div>
    </div>
    <div class="column">
      <div class="title is-4 has-text-primary">{{ $t("champion") }}</div>
      <div
        class="button is-medium"
        v-bind:class="{ 'is-warning': match_2_winner }"
      >
        <span class="icon">
          <i class="fa fa-trophy"></i>
        </span>
        <span>{{ match_2_winner }}</span>
      </div>
    </div>
    <div class="column">
      <div class="title is-5">{{ $t("final") }}</div>
      <div>
        <div
          class="button is-medium match2"
          v-bind:class="{
            'is-info':
              match_2_winner &&
              match_1_winner &&
              match_2_winner == match_1_winner,
          }"
          @click="win(2, match_1_winner, $event)"
        >
          {{ match_1_winner }}
        </div>
      </div>
    </div>
    <div class="column">
      <div class="title is-5">{{ $t("semifinal") }}</div>
      <div class="mb-5">
        <div
          class="button is-medium match1"
          v-bind:class="{
            'is-info': match_1_winner && match_1_winner == players[2],
          }"
          @click="win(1, players[2], $event)"
        >
          {{ players[2] }}
        </div>
      </div>
      <div>
        <div
          class="button is-medium match1"
          v-bind:class="{
            'is-info': match_1_winner && match_1_winner == players[3],
          }"
          @click="win(1, players[3], $event)"
        >
          {{ players[3] }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FourPeople",
  props: {
    players: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      match_0_winner: "",
      match_1_winner: "",
      match_2_winner: "",
    };
  },
  methods: {
    win(round, player, event) {
      if (round === 0) {
        this.match_0_winner = player;
        window.jQuery(".match0").removeClass("is-info");
        window.jQuery(event.target).addClass("is-info");
      } else if (round === 1) {
        this.match_1_winner = player;
        window.jQuery(".match1").removeClass("is-info");
        window.jQuery(event.target).addClass("is-info");
      } else if (round === 2) {
        this.match_2_winner = player;
        window.jQuery(".match2").removeClass("is-info");
        window.jQuery(event.target).addClass("is-info");
      }
    },
    get_results() {
      return {
        matches: {
          0: {
            winner: this.match_0_winner,
            players: [this.players[0], this.players[1]],
          },
          1: {
            winner: this.match_1_winner,
            players: [this.players[2], this.players[3]],
          },
          2: {
            winner: this.match_2_winner,
            players: [this.match_0_winner, this.match_1_winner],
          },
        },
      };
    },
    set_results(results) {
      let v = this;
      if (results && results.matches) {
        if (results.matches[0]) {
          v.match_0_winner = results.matches[0].winner;
        }
        if (results.matches[1]) v.match_1_winner = results.matches[1].winner;
        if (results.matches[2]) v.match_2_winner = results.matches[2].winner;
      }
    },
  },
  watch: {},
};
</script>

<style scoped>
/* Your styles here */
</style>
